import React, { useEffect, useLayoutEffect } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { LoginScreen } from '../login/LoginScreen';
import { LoginMobileCaScreen } from '../login/LoginMobileCaScreen';
import { FoundLostPet } from '../foundLostPet/FoundLostPet';
import GenericError from '../genericError/GenericError';
import {
  UpdatePaymentMethodScreen,
} from '../updatePaymentMethod/UpdatePaymentMethodScreen';
import RedirectCustomerId from './RedirectCustomerId';
import { LoginMobile } from '../login/LoginMobile';
import { ChangeCoverageScreen } from '../changeCoverage/ChangeCoverageScreen';
import { SharePost } from '../sharePost/SharePost';
import {
  DownloadMobileApplications,
} from '../downloadMobileApplications/DownloadMobileApplications';

import * as routes from './routes.constants';
import { isMobile, updateOsanoLocale } from '../../services/utils';
import { TermsOfUseScreen } from '../contentfulPages/TermsOfUseScreen';
import { PrivacyPolicyScreen } from '../contentfulPages/PrivacyPolicyScreen';
import { WelcomeScreen } from '../petDemographics';
import { useQuery } from '../../hooks';
import {
  CertificateLinkingScreen,
} from '../petDemographics/certificateLinking';
import { LANGUAGES_EN_US, LANGUAGES_FR_CA } from '../../i18n';

const PublicRouter = (props) => {
  const showGenericError =
    useSelector(({ common }) => (common.showGenericError), shallowEqual);
  const query = useQuery();
  const { i18n } = useTranslation('');

  const language = query.get('language');

  const mobile = React.useMemo(() => isMobile(), []);

  useEffect(() => {
    if (showGenericError) {
      props.history.push(routes.ERROR);
    }
  }, [showGenericError]);

  useLayoutEffect(() => {
    if (language) {
      updateOsanoLocale(language);

      i18n.language = language; // for api usage
      i18n.changeLanguage(language);
    }
  }, [language]);

  return (
    <Switch>
      <Route
        exact
        onEnter={window.location.reload}
        path={routes.IOS_URL}
      />

      <Route exact path="/welcome-ca">
        <LoginMobileCaScreen />
      </Route>

      <Route exact path="/">
        {mobile ? <LoginMobile /> : <LoginScreen />}
      </Route>

      <Route path={routes.B2C_TOKEN_REGISTER}>
        <LoginScreen registerToken />
      </Route>

      <Route exact path={routes.REDIRECT}>
        <LoginScreen />
      </Route>

      <Route exact path={routes.LOGIN}>
        <RedirectCustomerId />
      </Route>

      <Route path={routes.IMPERSONATE}>
        <LoginScreen isImpersonate />
      </Route>

      <Route exact path={routes.WELCOME_DEMOGRAPHICS}>
        <WelcomeScreen />
      </Route>

      <Route exact path={routes.DEMOGRAPHICS}>
        <CertificateLinkingScreen />
      </Route>

      <Route exact path={routes.FOUND_LOST_PET}>
        <FoundLostPet />
      </Route>

      <Route exact path={routes.TERMS_OF_USE}>
        <TermsOfUseScreen language={LANGUAGES_EN_US} />
      </Route>

      <Route exact path={routes.TERMS_OF_USE_FR}>
        <TermsOfUseScreen language={LANGUAGES_FR_CA} />
      </Route>

      <Route exact path={routes.PRIVACYPOLICY}>
        <PrivacyPolicyScreen />
      </Route>

      <Route exact path={routes.PRIVACY_POLICY}>
        <PrivacyPolicyScreen language={LANGUAGES_EN_US} />
      </Route>

      <Route exact path={routes.VIE_PRIVEE}>
        <PrivacyPolicyScreen language={LANGUAGES_FR_CA} />
      </Route>

      <Route path={routes.ERROR}>
        <GenericError />
      </Route>

      <Route path={`${routes.POST_SHARE}/:postId`}>
        <SharePost />
      </Route>

      <Route path={routes.CHANGE_COVERAGE}>
        <ChangeCoverageScreen />
      </Route>

      <Route path={routes.PAYMENT_METHOD_EDIT}>
        <UpdatePaymentMethodScreen />
      </Route>

      <Route path={routes.DOWNLOAD_MOBILE_APPS}>
        <DownloadMobileApplications />
      </Route>

      <Route path="*">
        {mobile ? <LoginMobile /> : <Redirect to="/" />}
      </Route>
    </Switch>
  );
};

export default withRouter(PublicRouter);
